/**
* Testimonials Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonials Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'testimonials-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      document.querySelectorAll( this.selector() ).forEach( ( root ) => {
        this._initRow( root, '.testimonials-marquee__top-splide', /* reverse = */ false );
        this._initRow( root, '.testimonials-marquee__bottom-splide', /* reverse = */ true );
      } );
    },

    _initRow( root, sel, reverse ) {
      const el = root.querySelector( sel );
      if ( ! el ) return;

      // 1) Mount Splide—with loop & autoWidth & clones
      const slideCount = el.querySelectorAll( '.splide__slide' ).length;
      const splide = new Splide( el, {
        type: 'loop', // infinite loop :contentReference[oaicite:0]{index=0}
        autoWidth: true,
        gap: '48px',
        arrows: false,
        pagination: false,
        clones: slideCount, // full set of off-screen clones
        breakpoints: {1024: {perPage: 3}, 768: {perPage: 2}},
      } ).mount();

      // 2) Wrap the track’s .splide__list + its clone in our marquee-wrapper
      const track = el.querySelector( '.splide__track' );
      const list = track.querySelector( '.splide__list' );
      const wrapper = document.createElement( 'div' );
      wrapper.classList.add( 'marquee-wrapper' );

      track.innerHTML = ''; // clear out the old list
      track.appendChild( wrapper ); // insert our wrapper
      wrapper.appendChild( list ); // original slides
      wrapper.appendChild( list.cloneNode( true ) ); // duplicate for seamless loop

      // 3) Continuous scroll with requestAnimationFrame
      let offset = 0;
      let paused = false;
      const speed = 0.1; // px per millisecond → ~300px/sec
      let lastTime = performance.now();

      function step( now ) {
        const dt = now - lastTime;
        lastTime = now;
        if ( ! paused ) {
          offset += ( reverse ? -1 : 1 ) * speed * dt;
          const width = list.scrollWidth;
          // wrap into [0, width)
          offset = ( offset % width + width ) % width;
          wrapper.style.transform = `translateX(${-offset}px)`;
        }
        requestAnimationFrame( step );
      }
      requestAnimationFrame( step );

      // 4) Pause on hover
      wrapper.addEventListener( 'mouseenter', () => {
        paused = true;
      } );
      wrapper.addEventListener( 'mouseleave', () => {
        paused = false;
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonials-marquee', COMPONENT );
} )( app );
